module.exports = __webpack_public_path__ + "static/media/c12_1.732311f4.png";